import api from './api';
import { Feiertag, FeiertagStatus } from '../types';

export const feiertagService = {
  getByJahr: async (jahr?: number): Promise<Feiertag[]> =>
    (await api.get('/feiertage', { params: jahr ? { jahr } : {} })).data,

  status: async (jahr: number): Promise<FeiertagStatus> =>
    (await api.get('/feiertage/status', { params: { jahr } })).data,

  abrufen: async (jahr: number): Promise<{ jahr: number; anzahl: number }> =>
    (await api.post('/feiertage/abrufen', null, { params: { jahr } })).data,

  anlegen: async (datum: string, name: string): Promise<Feiertag> =>
    (await api.post('/feiertage', { datum, name })).data,
};

export default feiertagService;
